import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import CUIButton from 'connect-dot-com-ui-components/Components/CUIButton/CUIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackInteraction } from '../../utils/usageTracker';
import enviro from 'enviro';

const LoginButton = (_ref) => {
  let {
    trackingIdentifier,
    variant = 'secondary',
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["trackingIdentifier", "variant", "children"]);

  return /*#__PURE__*/_jsx(CUIButton, Object.assign({
    variant: variant,
    as: "a",
    href: `https://app.hubspot${enviro.isQa() ? 'qa' : ''}.com/connect-beta/auth-redirect`,
    onClick: () => trackInteraction('click login button', {
      identifier: trackingIdentifier
    })
  }, rest, {
    children: children || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.homepage.header.signIn"
    })
  }));
};

export default LoginButton;